import * as React from 'react';
import { Select } from 'antd';

export interface IBusinessSelectProps {
  name: string;
  value: string | undefined;
  business?: Array<GQL.IBusiness>;
  style?: any;
  onChange: (e: any, business: GQL.IBusiness | undefined) => void;
}

export class BusinessSelect extends React.PureComponent<IBusinessSelectProps> {

  constructor(props: IBusinessSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, business } = this.props;

    const placeholder = 'Choose business';

    if (business) {
      return (
        <Select
          placeholder={placeholder}
          onChange={this.onChange}
          value={value}
          style={...style}
          allowClear={true}
        >
          {business
            .map((b: GQL.IBusiness) => {
              return (
                <Select.Option key={b.id} value={b.id}>
                  {b.name}
                </Select.Option>
              );
            })}
        </Select>
      );
    }

    return (
      <Select placeholder={placeholder} style={...style} />
    );
  }

  private onChange(value: string) {
    const business = this.props.business && this.props.business.find((l: GQL.IBusiness) => l.id === value);

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      }, business);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/BusinessSelect/BusinessSelect.tsx